import {Breadcrumbs} from "../../components/breadcrumbs/breadcrumbs";
import {MenuForm} from "../../components/form/menuForm";
import {useGlobalContext} from "../../hooks/globalContext";
import {useEffect} from "react";

export function CreateNewMenu() {
    const {i18n} = useGlobalContext()
    let infos = [
        {link: "/menu/create", title: i18n.add_menu(), index: "breadcrumbs-id"}
    ]
    useEffect(() => {
        document.title = i18n.menu_creating()
    }, [i18n])
    return (
        <section className="app__main">
            <main role="main" className="app__content">

                <Breadcrumbs infos={infos}/>


                <div className="app__header">
                    <div className="app__header-left">
                        <h1 className="app__header-title">{i18n.add_menu()}</h1>
                    </div>
                </div>


                <div className="row">
                    <div className="col-lg-8 col-xl-5">
                        <div className="default-card">

                            <MenuForm/>

                        </div>
                    </div>
                </div>

            </main>
        </section>
    )
}